import { create } from 'zustand'

interface IdleState {
  isIdle: boolean
  isScreensaverActive: boolean
  setIdle: (idle: boolean) => void
  setScreensaverActive: (active: boolean) => void
  wakeUp: () => void
}

export const useIdleStore = create<IdleState>()((set) => ({
  isIdle: false,
  isScreensaverActive: false,
  setIdle: (idle) => set({ isIdle: idle }),
  setScreensaverActive: (active) => set({ isScreensaverActive: active }),
  wakeUp: () => set({ isIdle: false, isScreensaverActive: false })
}))
